import React, { useRef } from 'react';
import { useDrop, DndProvider, useDrag } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Row, Col, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export function OrderDetails({ fromForm, dropLocation, index }) {
  const { t } = useTranslation('common');

  function ODDetails() {
    const odRef = useRef(null);

    const [{ item, handlerId, isOver }, drop] = useDrop({
      accept: 'container',
      drop: () => {
        dropLocation(index, item);
      },
      collect: (monitor) => ({
        item: monitor.getItem(),
        handlerId: monitor.getHandlerId(),
        isOver: monitor.isOver(),
      }),
    });

    const [{ itemDragging }] = useDrag({
      type: 'container',
      collect: (monitor) => ({
        itemDragging: monitor.getItem(),
      }),
    });

    drop(odRef);
    return (
      <div ref={odRef} data-handler-id={handlerId} key={`OrderDetails_${index}`}>
        {isOver && <div className="potemplate-drag-placeholder">{t('PO_TEMPLATES.PO_DETAILS.ORDER_DETAILS.PLACEHOLDER_DROP')}</div>}
        <Card className="listing-card">
          <Card.Header className="py-2 px-2 bgcolor-dark">
            <strong>{t('PO_TEMPLATES.PO_DETAILS.ORDER_DETAILS.ORDER_HEADER')}</strong>
          </Card.Header>
          {itemDragging?.type !== 'container' && (
            <Card.Body>
              <Row>
                <Col lg={6}>
                  <ul className="order-detail-list">
                    <li>
                      <b>{t('PO_TEMPLATES.PO_DETAILS.ORDER_DETAILS.PRODUCT_NUMBER')}</b>
                    </li>
                    <li>
                      <b>{t('PO_TEMPLATES.PO_DETAILS.ORDER_DETAILS.PRODUCT_DESCRIPTION')}</b>
                    </li>
                    <li>
                      <b>{t('PO_TEMPLATES.PO_DETAILS.ORDER_DETAILS.SEASON')}</b>
                    </li>
                    <li>
                      <b>{t('PO_TEMPLATES.PO_DETAILS.ORDER_DETAILS.BRAND')}</b>
                    </li>
                  </ul>
                </Col>
                <Col lg={6}>
                  <ul className="order-detail-list">
                    <li>
                      <b>{t('PO_TEMPLATES.PO_DETAILS.ORDER_DETAILS.CATEGORY_1')}</b>
                    </li>
                    <li>
                      <b>{t('PO_TEMPLATES.PO_DETAILS.ORDER_DETAILS.CATEGORY_2')}</b>
                    </li>
                    <li>
                      <b>{t('PO_TEMPLATES.PO_DETAILS.ORDER_DETAILS.CATEGORY_3')}</b>
                    </li>
                    <li>
                      <b>{t('PO_TEMPLATES.PO_DETAILS.ORDER_DETAILS.CATEGORY_4')}</b>
                    </li>
                  </ul>
                </Col>
              </Row>
            </Card.Body>
          )}
        </Card>
      </div>
    );
  }
  return (
    <DndProvider backend={HTML5Backend}>
      {fromForm ? (
        <ODDetails />
      ) : (
        <Card className="listing-card">
          <Card.Header className="py-2 px-2 bgcolor-dark">
            <strong>{t('PO_TEMPLATES.PO_DETAILS.ORDER_DETAILS.ORDER_HEADER')}</strong>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col lg={6}>
                <ul className="order-detail-list">
                  <li>
                    <b>{t('PO_TEMPLATES.PO_DETAILS.ORDER_DETAILS.PRODUCT_NUMBER')}</b>
                  </li>
                  <li>
                    <b>{t('PO_TEMPLATES.PO_DETAILS.ORDER_DETAILS.PRODUCT_DESCRIPTION')}</b>
                  </li>
                  <li>
                    <b>{t('PO_TEMPLATES.PO_DETAILS.ORDER_DETAILS.SEASON')}</b>
                  </li>
                  <li>
                    <b>{t('PO_TEMPLATES.PO_DETAILS.ORDER_DETAILS.BRAND')}</b>
                  </li>
                </ul>
              </Col>
              <Col lg={6}>
                <ul className="order-detail-list">
                  <li>
                    <b>{t('PO_TEMPLATES.PO_DETAILS.ORDER_DETAILS.CATEGORY_1')}</b>
                  </li>
                  <li>
                    <b>{t('PO_TEMPLATES.PO_DETAILS.ORDER_DETAILS.CATEGORY_2')}</b>
                  </li>
                  <li>
                    <b>{t('PO_TEMPLATES.PO_DETAILS.ORDER_DETAILS.CATEGORY_3')}</b>
                  </li>
                  <li>
                    <b>{t('PO_TEMPLATES.PO_DETAILS.ORDER_DETAILS.CATEGORY_4')}</b>
                  </li>
                </ul>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      )}
    </DndProvider>
  );
}

export default OrderDetails;
